import { motion } from "framer-motion";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export function Reveal({ children, className = "", delay = 0, variants = fadeUp }) {
  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      transition={{ delay }}
    >
      {children}
    </motion.div>
  );
}

export function RevealGroup({ children, className = "" }) {
  return (
    <motion.div
      className={className}
      variants={stagger}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
    >
      {children}
    </motion.div>
  );
}
